import { Input, Text } from "components/base/Form";
import useSavePackaging from "../../useSavePacking";

const StellaView = ({ pkg, disabled }) => {
  const { state, onChange, loading } = useSavePackaging(
    pkg.id,
    "item",
    JSON.parse(pkg.item),
  );

  return (
    <div className="-mx-2 mt-4 whitespace-nowrap">
      <table>
        <tbody>
          <tr>
            <td className="text-orange-500 font-semibold">Stella</td>
            <td className="w-full"></td>
          </tr>

          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Item Number:</td>
            <td>
              <Input
                className="w-full"
                value={state.number}
                onChange={(e) => {
                  onChange("number", e.target.value);
                }}
                readOnly={disabled}
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Barcode(s):</td>
            <td>
              <Input
                className="w-full"
                value={state.barcodes}
                onChange={(e) => onChange("barcodes", e.target.value)}
                readOnly={disabled}
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Trademark Registered:</td>
            <td>
              <input
                type="checkbox"
                checked={state.trademarkRegistered}
                onChange={(e) =>
                  onChange("trademarkRegistered", e.target.checked, false)
                }
                disabled={disabled}
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Notes for Trademark:</td>
            <td className="whitespace-pre-wrap">
              <Text
                value={state.trademarkRemark}
                onChange={(e) => onChange("trademarkRemark", e.target.value)}
                readOnly={disabled}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default StellaView;
